import { useEffect } from "react";

export default function BackGroundLoad({ config }) {
  useEffect(() => {
    // 🔹 Set all window globals
    window.LogOut = LogOut;
    window.API_BASE_URL = config.API_BASE_URL || "https://demo.com:50100";
    window.LOGO = config.LOGO || "https://demo.com:50100/public/Logo/Demo.png";
    window.THEME_COLOR = config.THEME_COLOR || "#09093e";
    window.SERVER = config.SERVER || "DEMO";
    window.APP_NAME = config.APP_NAME || "DEMO";
    window.WEB_SOCKET = config.WEB_SOCKET || "https://demo.com:50200";
    window.ENTRYKEY = config.ENTRYKEY || "8cac8506d7d9770e860979dc1fdda821";
    window.WEBSITE_LINK = config.WEBSITE_LINK || "https://demo.com";
    window.APP_DOWNLOAD_LINK =
      config.APP_DOWNLOAD_LINK ||
      "https://demo.com:30100/public/App/Demo.apk";
    window.APP_LINK = config.APP_LINK || "https://demo.com";
    window.APP_LINK_IOS = config.APP_LINK_IOS || "https://demo.com";
    window.APP_LINK_ANDROID = config.APP_LINK_ANDROID || "https://demo.com";

    // 🔹 Update Page Title
    document.title = config.APP_NAME || "Trading App";

    // 🔹 Set favicon dynamically
    const favicon =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    favicon.rel = "icon";
    favicon.href = config.ICO || "/favicon.ico";
    document.head.appendChild(favicon);

    // 🔹 Update theme color dynamically
    let themeMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeMeta) {
      themeMeta = document.createElement("meta");
      themeMeta.name = "theme-color";
      document.head.appendChild(themeMeta);
    }
    themeMeta.content = "#FFFFFF";

    // 🔹 Dynamically create manifest.json
    const manifest = {
      short_name: config.APP_NAME || "App",
      name: config.APP_NAME || "App",
      icons: [
        {
          src: config.ICO || "/favicon.ico",
          sizes: "64x64 32x32 24x24 16x16",
          type: "image/x-icon",
        },
        {
          src: config.LOGO192 || "/logo192.png",
          type: "image/png",
          sizes: "192x192",
        },
        {
          src: config.LOGO512 || "/logo512.png",
          type: "image/png",
          sizes: "512x512",
        },
      ],
      start_url: ".",
      display: "standalone",
      theme_color: config.THEME_COLOR || "#ffffff",
      background_color: "#ffffff",
    };

    const stringManifest = JSON.stringify(manifest);
    const blob = new Blob([stringManifest], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);

    // 🔹 Inject dynamic manifest link
    let manifestLink = document.querySelector('link[rel="manifest"]');
    if (!manifestLink) {
      manifestLink = document.createElement("link");
      manifestLink.rel = "manifest";
      document.head.appendChild(manifestLink);
    }
    manifestLink.href = manifestURL;

    // 🔹 Optional: Add Apple Touch icon for iOS
    const appleIcon =
      document.querySelector("link[rel='apple-touch-icon']") ||
      document.createElement("link");
    appleIcon.rel = "apple-touch-icon";
    appleIcon.href = config.LOGO512 || "/logo512.png";
    document.head.appendChild(appleIcon);
  }, [config]);

  // 🔹 Logout function
  const LogOut = () => {
    const accountsList = localStorage.getItem("accountsList");
    const themeType = localStorage.getItem("themeType");

    localStorage.clear();

    if (accountsList) {
      localStorage.setItem("accountsList", accountsList);
      localStorage.setItem("themeType", themeType);
    }

    window.location.href = "/";
  };

  return null;
}
